var config = {
    API: 'https://www.bamboo-nutricion.com/api/',
    //API: 'http://192.168.0.161:4000/api/',
    path: 'https://www.bamboo-nutricion.com/app/#/',
    //path: 'http://192.168.0.161:3000/#/'
};

module.exports = config;
